import { AlertTriangle } from 'lucide-react';
import { useIsMobile } from 'hooks/useIsMobile';
import { AlertBanner } from './AlertBanner';

export function GlobalPluginAlert({ onClose }: { onClose?: () => void }) {
  const isMobile = useIsMobile();
  if (isMobile) return null;

  return (
    <AlertBanner icon={AlertTriangle} chip="Notice" heading="Pertento Editor" onClose={onClose}>
      The Editor requires our browser plugin. Install the plugin to start editing.{' '}
      <a
        target="_blank"
        className="text-accent hover:underline"
        href="https://chromewebstore.google.com/detail/pertento-editor/fjooappefigppfjolhadliepialebodg"
      >
        Install the plugin
      </a>
    </AlertBanner>
  );
}
